import customAxios from "./axiosConfig";

const TimerService = {
  start: function (data) {
    var api_url = window.Urls["hours_api_start_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  resume: function (data) {
    var api_url = window.Urls["hours_api_restart_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  pause: function (data) {
    var api_url = window.Urls["hours_api_pause_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  destroyTimer: function (data) {
    var api_url = window.Urls["hours_api_destroy_timer"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  changeProject: function (data) {
    var api_url = window.Urls["hours_api_change_timer_project"]();
    var headers = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };
    return customAxios.post(api_url, data, headers);
  },
  getTimers: function () {
    var api_url = window.Urls["hours_api_get_timers"]();
    return customAxios.get(api_url);
  },
  getRunningTimer: function () {
    var api_url = window.Urls["hours_api_get_running_timer"]();
    return customAxios.get(api_url);
  },
};

export default TimerService;